import CMS from 'netlify-cms-app'
import uploadcare from 'netlify-cms-media-library-uploadcare'
import cloudinary from 'netlify-cms-media-library-cloudinary'

import ArtistPagePreview from './preview-templates/ArtistPagePreview'
import BlogPostPreview from './preview-templates/BlogPostPreview'
import ContactPagePreview from './preview-templates/ContactPagePreview'
import DialogscapesPreview from './preview-templates/DialogscapesPreview'
import FluidFilmLabPagePreview from './preview-templates/FluidFilmLabPagePreview'
import GyptRecordsPagePreview from './preview-templates/GyptRecordsPagePreview'
import IndexPagePreview from './preview-templates/IndexPagePreview'
import ProjectsPagePreview from './preview-templates/ProjectsPagePreview'

CMS.registerMediaLibrary(uploadcare)
CMS.registerMediaLibrary(cloudinary)

CMS.registerPreviewTemplate('index', IndexPagePreview)
CMS.registerPreviewTemplate('artists', ArtistPagePreview)
CMS.registerPreviewTemplate('blog', BlogPostPreview)
CMS.registerPreviewTemplate('contact', ContactPagePreview)
CMS.registerPreviewTemplate('dialogscapes', DialogscapesPreview)
CMS.registerPreviewTemplate('fluid-film-lab', FluidFilmLabPagePreview)
CMS.registerPreviewTemplate('gypt-records', GyptRecordsPagePreview)
CMS.registerPreviewTemplate('projects', ProjectsPagePreview)
